import { Leaf, ShieldCheck, Sparkles, HeartHandshake } from "lucide-react";

const pillars = [
  {
    icon: ShieldCheck,
    title: "Clinically led",
    body: "Ongoing education and professional development are integral to providing safe, current, and effective aesthetic care. Face It Aesthetics maintains registration with AHPRA and operates under appropriate medical governance for all prescription treatments.",
  },
  {
    icon: HeartHandshake,
    title: "Personal, never templated",
    body: "No two faces are the same. Treatment plans are designed around your unique anatomy, skin quality, and personal goals — never a one-size-fits-all approach.",
  },
  {
    icon: Sparkles,
    title: "Subtle, refined results",
    body: "Realistic expectations are set from the very first consultation. We never overstate outcomes or minimise risks. Informed consent is central to everything we do.",
  },
  {
    icon: Leaf,
    title: "Regenerative philosophy",
    body: "A growing focus on regenerative therapies that work with the skin's own biology.",
  },
];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-32 reveal">
            <p className="overline">The Philosophy</p>
            <h2 className="font-serif-luxe mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02]">
              Four quiet <em className="text-[#8C6A53]">commitments</em>
              <br />we treat as non-negotiable.
            </h2>
          </div>
          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-6">
            {pillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={p.title}
                  data-testid={`pillar-${p.title.split(" ")[0].toLowerCase()}`}
                  className="reveal bg-white border border-[#E8E1DA] rounded-3xl p-8 hover:shadow-[0_8px_30px_rgba(140,106,83,0.08)] transition-all duration-500"
                  style={{ transitionDelay: `${i * 100}ms` }}
                >
                  <div className="w-12 h-12 rounded-full bg-[#F5ECE1] flex items-center justify-center mb-6">
                    <Icon size={20} className="text-[#8C6A53]" />
                  </div>
                  <h3 className="font-serif-luxe text-2xl text-[#2C2723]">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#5C534B]">
                    {p.body}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
